import { ChevronLeft, ChevronRight } from "lucide-react";

const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const CATEGORY_COLORS = {
  social: "bg-rose-100 text-rose-800", fitness: "bg-emerald-100 text-emerald-800", class: "bg-sky-100 text-sky-800",
  meeting: "bg-slate-200 text-slate-800", dining: "bg-amber-100 text-amber-800", holiday: "bg-fuchsia-100 text-fuchsia-800",
  kids: "bg-lime-100 text-lime-800", trip: "bg-teal-100 text-teal-800", service: "bg-indigo-100 text-indigo-800", other: "bg-sand-200 text-ink",
};

export const monthKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
export const monthLabel = (key) => { const [y, m] = key.split("-").map(Number); return new Date(y, m - 1, 1).toLocaleDateString(undefined, { month: "long", year: "numeric" }); };
export const shiftMonth = (key, n) => { const [y, m] = key.split("-").map(Number); return monthKey(new Date(y, m - 1 + n, 1)); };

// A plain month grid — each cell lists that day's events; click to open.
export function EventsCalendar({ month, items, today, onMonth, onOpen, testid = "events-calendar" }) {
  const [y, m] = month.split("-").map(Number);
  const first = new Date(y, m - 1, 1);
  const days = new Date(y, m, 0).getDate();
  const lead = first.getDay();
  const byDay = {};
  for (const e of items) { if (e.date) (byDay[e.date] = byDay[e.date] || []).push(e); }
  const cells = [...Array(lead).fill(null), ...Array.from({ length: days }, (_, i) => i + 1)];
  while (cells.length % 7) cells.push(null);
  return (
    <div data-testid={testid} className="bg-white rounded-2xl border border-sand-200 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-sand-100">
        <button data-testid={`${testid}-prev`} onClick={() => onMonth(shiftMonth(month, -1))} className="h-8 w-8 rounded-lg border border-sand-200 flex items-center justify-center hover:border-ink"><ChevronLeft className="h-4 w-4" /></button>
        <div className="font-heading font-bold text-ink" data-testid={`${testid}-month`}>{monthLabel(month)}</div>
        <button data-testid={`${testid}-next`} onClick={() => onMonth(shiftMonth(month, 1))} className="h-8 w-8 rounded-lg border border-sand-200 flex items-center justify-center hover:border-ink"><ChevronRight className="h-4 w-4" /></button>
      </div>
      <div className="grid grid-cols-7 text-[10px] uppercase tracking-wider font-bold text-ink/40 border-b border-sand-100">
        {DOW.map((d) => <div key={d} className="px-2 py-1.5 text-center">{d}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {cells.map((day, idx) => {
          const iso = day ? `${month}-${String(day).padStart(2, "0")}` : null;
          const evs = iso ? byDay[iso] || [] : [];
          const isToday = iso === today;
          return (
            <div key={idx} data-testid={iso ? `${testid}-day-${iso}` : undefined}
              className={`min-h-[84px] sm:min-h-[104px] border-b border-r border-sand-100 p-1.5 ${day ? "" : "bg-sand-50/50"} ${(idx + 1) % 7 === 0 ? "border-r-0" : ""}`}>
              {day && (
                <div className={`text-[11px] font-bold mb-1 ${isToday ? "inline-flex h-5 w-5 items-center justify-center rounded-full bg-redline-500 text-white" : iso < today ? "text-ink/30" : "text-ink/60"}`}>{day}</div>
              )}
              <div className="space-y-0.5">
                {evs.slice(0, 3).map((e) => (
                  <button key={e.id} data-testid={`${testid}-event-${e.id}`} onClick={() => onOpen(e)} title={`${e.title}${e.time ? ` · ${e.time}` : ""}`}
                    className={`w-full text-left truncate rounded px-1.5 py-0.5 text-[10px] sm:text-[11px] font-semibold ${CATEGORY_COLORS[e.category] || CATEGORY_COLORS.other} hover:opacity-80`}>
                    {e.time ? <span className="opacity-70 mr-1">{e.time.replace(/:00/, "").replace(/\s?([AP])M/i, "$1").toLowerCase()}</span> : null}{e.title}
                  </button>
                ))}
                {evs.length > 3 && <div className="text-[10px] text-ink/50 px-1">+{evs.length - 3} more</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
